var render = function render(){var _vm=this,_c=_vm._self._c;return _c('KButton',{attrs:{"primary":"","text":"Dropdown Button"},scopedSlots:_vm._u([{key:"menu",fn:function(){return [_c('KDropdownMenu',{attrs:{"hideOnClick":false,"constrainToScrollParent":false,"options":[{ label: 'Option 1' }, { label: 'Option 2' }]}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }